export interface FloorPlanProperties {}

export module FloorPlanProperties {
  export const defaultValue: Readonly<FloorPlanProperties> = {};
}
